import { Component, ReactNode } from "react"
import { Box, Text, Button } from "@chakra-ui/react"

interface Props {
  children: ReactNode
  fallback?: ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
}

export class FormErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("[FormErrorBoundary]", error, errorInfo)
  }

  render() {
    if (this.state.hasError && this.state.error) {
      if (this.props.fallback) return this.props.fallback
      return (
        <Box p={6} bg="gray.50" borderRadius="md" borderWidth="1px" borderColor="red.200">
          <Text fontWeight="bold" color="red.600" mb={2}>
            Something went wrong loading this form
          </Text>
          <Text fontSize="sm" color="gray.700" mb={4} fontFamily="mono">
            {this.state.error.message}
          </Text>
          <Button
            size="sm"
            onClick={() => this.setState({ hasError: false, error: null })}
          >
            Try again
          </Button>
        </Box>
      )
    }
    return this.props.children
  }
}
